<template>
  <div class="payment-page">
    <van-loading v-if="loading" class="payment-loading" type="spinner" vertical>加载中...</van-loading>

    <template v-else>
      <!-- 顶部：赛事 + 状态 + 时间 -->
      <div class="payment-header">
        <div class="payment-header-main">
          <div class="payment-title-row">
            <h1 class="payment-match-name">{{ order.matchName || '—' }}</h1>
            <span class="payment-status" :class="statusClass">{{ orderStatusText }}</span>
          </div>
          <p v-if="headerTimeText" class="payment-header-time">{{ headerTimeText }}</p>
        </div>
      </div>

      <!-- 订单信息 -->
      <div class="payment-card">
        <div class="payment-section-title">订单信息</div>
        <div class="payment-kv">
          <div class="payment-row">
            <span class="payment-label">{{ firstRowLabel }}</span>
            <span class="payment-value">{{ firstRowValue }}</span>
          </div>
          <div class="payment-row">
            <span class="payment-label">报名组别</span>
            <span class="payment-value">{{ groupDisplay }}</span>
          </div>
        </div>
        <div class="payment-total">
          <span class="payment-total-label">订单总额</span>
          <span class="payment-total-amount">¥ {{ amountYuan }}</span>
        </div>
      </div>

      <div class="payment-gap" />

      <!-- 付款信息 -->
      <div class="payment-card">
        <div class="payment-section-title">付款信息</div>
        <div class="payment-kv">
          <div class="payment-row">
            <span class="payment-label">订单号</span>
            <span class="payment-value payment-value--mono">{{ orderNoDisplay }}</span>
          </div>
          <div class="payment-row">
            <span class="payment-label">付款方式</span>
            <span class="payment-value">{{ payMethodText }}</span>
          </div>
          <div class="payment-row">
            <span class="payment-label">创建时间</span>
            <span class="payment-value">{{ createTimeDisplay }}</span>
          </div>
          <div class="payment-row">
            <span class="payment-label">付款时间</span>
            <span class="payment-value">{{ payTimeDisplay }}</span>
          </div>
        </div>
      </div>

      <div class="payment-bottom-spacer" />
    </template>

    <div class="payment-bottom">
      <span
        v-if="canCancelOrder && false"
        class="payment-cancel"
        :style="{ color: payBtnBg }"
        @click="onCancelOrder"
      >取消订单</span>
      <van-button
        class="payment-pay-btn"
        type="info"
        round
        @click="bangsaishiCheckTeamSignupOrder"
      >
        支付
      </van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Loading, Dialog } from 'vant'
import { getWXInfo, removeToken } from '@/libs/cookie-storage'
import {
  getOrderDetail,
  getWechatPrepayInfo,
  bangsaishiCheckTeamSignupOrder,
  bangsaishiCreateTeamSignupOrder,
  bangsaishiCreatePlayerSignupOrder,
  cancelEventOrder
} from '@/api/match'
import { ConstConfig } from '@/constants'
import { UrlUtil, isWeChatMiniApp, DateUtil } from '@/utils'
import { getPassport } from '@/libs/passport'
import { AppType } from '@/constants/appType'
import wx from 'weixin-js-sdk'

Vue.use(Button).use(Loading).use(Dialog)

export default {
  name: 'payment',
  data() {
    return {
      loading: true,
      orderId: '',
      unionMatchId: '',
      order: {},
      type: '微信支付',
      category: 0,
      matchId: '',
      teamId: '',
      playerId: '',
      jetlympic: false
    }
  },
  computed: {
    primaryColor() {
      return this.jetlympic ? '#00A7FF' : '#1989fa'
    },
    payBtnBg() {
      return this.jetlympic ? '#00A7FF' : '#1a1a2e'
    },
    /** 队员支付：队员姓名；否则队伍名称（组合等多人可能含「/」仍用队员姓名式展示） */
    firstRowLabel() {
      return this.category === 1 ? '队员姓名' : '队伍名称'
    },
    firstRowValue() {
      return this.order.teamName || this.order.playerName || '—'
    },
    groupDisplay() {
      return (
        this.order.matchGroup || '—'
      )
    },
    amountYuan() {
      const raw = this.order.userPayment
      if (raw == null || raw === '') return '0.00'
      const n = Number(raw)
      return Number.isFinite(n) ? n.toFixed(2) : '0.00'
    },
    orderStatusText() {
      if (this.order.payTime || this.order.paidTime) return '已支付'
      const s = this.order.orderStatus
      if (s === 1 || s === '1' || s === 2 || s === '2') return '已支付'
      return '待支付'
    },
    statusClass() {
      return this.orderStatusText === '待支付' ? 'is-unpaid' : 'is-paid'
    },
    headerTimeText() {
      const t =
        this.order.orderTime ||
        this.order.gmtCreate ||
        this.order.createTime ||
        this.order.gmtModified
      return this.formatDateTime(t)
    },
    orderNoDisplay() {
      return (
        this.order.orderNo ||
        this.order.orderId ||
        this.order.id ||
        this.orderId ||
        '—'
      )
    },
    payMethodText() {
      return '微信支付'
    },
    createTimeDisplay() {
      const t = this.order.createDate
      return this.formatDateTime(t) || '—'
    },
    payTimeDisplay() {
      const t = this.order.payTime || this.order.paidTime || this.order.payFinishTime
      const formatted = this.formatDateTime(t)
      if (formatted) return formatted
      return '—'
    },
    externalOrderNoDisplay() {
      return this.order.outTradeNo || this.order.transactionId || this.order.wxTransactionId || ''
    },
    /** 仅待支付可取消 */
    canCancelOrder() {
      return this.orderStatusText === '待支付'
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    getPassport().then(() => {
      const category = this.$route.query.category || 0
      this.category = Number(category)
      this.unionMatchId = this.$route.query.unionMatchId
      this.orderId = this.$route.query.orderId
      this.matchId = this.$route.query.matchId
      this.teamId = this.$route.query.teamId
      this.playerId = this.$route.query.playerId
      this.getOrderDetail()
    })
  },
  methods: {
    formatDateTime(val) {
      if (val == null || val === '') return ''
      try {
        return DateUtil.parseDateTime(val, '{y}-{m}-{d} {h}:{i}')
      } catch (e) {
        void e
        return String(val)
      }
    },
    onCancelOrder() {
      if (!this.canCancelOrder || !this.orderId) return
      Dialog.confirm({
        title: '取消订单',
        message: '确定要取消该订单吗？',
        confirmButtonText: '确定',
        cancelButtonText: '我再想想'
      })
        .then(() => {
          return cancelEventOrder({ orderId: this.orderId })
        })
        .then(res => {
          if (res) {
            this.$toast.success('订单已取消')
            this.$router.back()
          }
        })
        .catch(() => {})
    },
    /** 支付完成后的默认落地页（含当前订单 id 与 category，供 GetOrderDetail 使用） */
    buildPaymentSuccessRedirectUrl() {
      const parts = [
        `unionMatchId=${encodeURIComponent(this.unionMatchId || '')}`,
        `matchId=${encodeURIComponent(this.matchId || '')}`,
        `teamId=${encodeURIComponent(this.teamId || '')}`,
        `orderId=${encodeURIComponent(this.orderId || '')}`,
        `category=${this.category}`
      ]
      if (this.playerId) {
        parts.push(`playerId=${encodeURIComponent(this.playerId)}`)
      }
      return `${process.env.VUE_APP_BM_MATCH}#/entry-page/payment-success?${parts.join('&')}`
    },
    /** 优先外部 SaaS 回跳；否则支付成功页 */
    resolvePayRedirectUrl() {
      const legacy = localStorage.getItem('saas-redirect')
      if (legacy) return legacy
      return this.buildPaymentSuccessRedirectUrl()
    },
    getOrderDetail() {
      this.loading = true
      const params = {
        orderId: this.orderId,
        category: this.category
      }
      getOrderDetail(params)
        .then(res => {
          if (res) {
            const { data } = res
            this.order = data || {}
            if (this.order.userPayment) {
              this.order.userPayment = (Number(this.order.userPayment) / 100).toFixed(2)
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    pay() {
      if (AppType.isInWeChat()) {
        isWeChatMiniApp().then(res => {
          if (res) {
            this.miniAppPayOrder(this.orderId)
          } else {
            this.getWechatPrepayInfo()
          }
        })
      } else {
        this.$toast('请在微信环境打开')
      }
    },
    bangsaishiCheckTeamSignupOrder() {
      bangsaishiCheckTeamSignupOrder({ orderId: this.orderId }).then(res => {
        if (res) {
          const { data } = res
          if (data.checkPrice) {
            this.pay()
          } else {
            if (this.category === 1) {
              bangsaishiCreatePlayerSignupOrder({
                matchId: this.matchId,
                teamId: this.teamId,
                playerId: this.playerId
              }).then(res2 => {
                if (res2) {
                  this.orderId = res2.data.orderId
                  this.pay()
                }
              })
            } else {
              bangsaishiCreateTeamSignupOrder({ matchId: this.matchId, teamId: this.teamId }).then(
                res2 => {
                  if (res2) {
                    this.orderId = res2.data.orderId
                    this.pay()
                  }
                }
              )
            }
          }
        }
      })
    },
    getWechatPrepayInfo() {
      const wxInfo = getWXInfo()
      if (!wxInfo?.openId) {
        if (AppType.isInWeChat()) {
          removeToken()
          this.$toast('请刷新页面后重试')
          return
        }
        this.$toast('请在微信环境打开')
        return
      }
      const data = {
        orderId: this.orderId,
        openId: wxInfo.openId,
        realPay: 1
      }
      getWechatPrepayInfo(data).then(res => {
        this.hrefWechatPay(res.data.payInfo.payInfo, this.orderId)
      })
    },
    hrefWechatPay(payInfo) {
      const redirectUrl = this.resolvePayRedirectUrl()
      localStorage.removeItem('saas-redirect')
      const payUrl =
        ConstConfig.payUrl +
        '?' +
        UrlUtil.queryObjectToString({
          t: Date.now(),
          payInfo: JSON.stringify(payInfo),
          redirectUrl
        })
      window.location.assign(payUrl)
    },
    miniAppPayOrder(orderId) {
      const redirectUrl = this.resolvePayRedirectUrl()
      localStorage.removeItem('saas-redirect')
      const url = `/pages/pay/index?orderId=${orderId}&redirectUrl=${encodeURIComponent(redirectUrl)}`
      wx.miniProgram.navigateTo({ url })
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-page {
  min-height: 100vh;
  background: #f6f6f8;
  padding-bottom: calc(88px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.payment-loading {
  padding: 80px 0;
}

.payment-header {
  background: #fff;
  padding: 16px 16px 14px;
  border-bottom: 1px solid #ebedf0;
}

.payment-header-main {
  padding-right: 0;
}

.payment-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.payment-match-name {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: 17px;
  font-weight: 600;
  color: #1d2129;
  line-height: 24px;
}

.payment-status {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

  &.is-unpaid {
    color: #ee0a24;
  }

  &.is-paid {
    color: #07c160;
  }
}

.payment-header-time {
  margin: 8px 0 0;
  font-size: 13px;
  color: #86909c;
  line-height: 18px;
}

.payment-card {
  // margin: 12px 12px 0;
  margin-top: 12px;
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px 16px;
  box-sizing: border-box;
}

.payment-section-title {
  font-size: 13px;
  color: #909399;
  margin-bottom: 12px;
  font-weight: 400;
}

.payment-kv {
  border-top: 1px solid #f0f0f0;
  padding-top: 4px;
}

.payment-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f5f6f7;

  &:last-child {
    border-bottom: none;
  }
}

.payment-label {
  flex-shrink: 0;
  font-size: 14px;
  color: #86909c;
  max-width: 42%;
}

.payment-value {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #1d2129;
  text-align: right;
  word-break: break-all;

  &--mono {
    font-family: ui-monospace, monospace;
    font-size: 13px;
  }
}

.payment-total {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.payment-total-label {
  font-size: 14px;
  color: #606266;
}

.payment-total-amount {
  font-size: 22px;
  font-weight: 600;
  color: var(--bg3);
  letter-spacing: -0.5px;
}

.payment-gap {
  height: 10px;
  margin: 0 12px;
  background: #f6f6f8;
  border-radius: 2px;
}

.payment-bottom-spacer {
  height: 24px;
}

.payment-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  padding-bottom: 28px;
  // padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.payment-cancel {
  flex-shrink: 0;
  font-size: 15px;
  font-weight: 500;
  line-height: 44px;
  cursor: pointer;
  user-select: none;
}

.payment-pay-btn {
  min-width: 112px;
  height: 44px;
  margin-left: auto;
  padding: 0 28px;
  font-size: 16px;
  font-weight: 500;
  background: var(--bg3);
  color: var(--bg1);
  border: none;
}
</style>
